module.exports = "float PI = 3.14159265;"